import { Component, Input, OnChanges, signal, type SimpleChanges } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-sidebar-section',
  standalone: true,
  imports: [ MatIconModule ],
  templateUrl: './sidebar-section.component.html',
  styleUrl: './sidebar-section.component.scss'
})
export class SidebarSectionComponent implements OnChanges {
  @Input() titleSection!: string;
  @Input() noSpaceTop: boolean = false;
  @Input() collapsible: boolean = false;
  @Input() hasSelected: boolean = false;
  /** The section contains something with changes not saved: while it is collapsed it shows a red dot, so that they are not forgotten */
  @Input() hasChanges: boolean = false;
  /** Text read for the red dot */
  @Input() changesLabel?: string;
  /**
   * Every time its value changes to a value that is not the last one it had (null and undefined are nothing) the section is expanded,
   * even if the user has collapsed it: going from a value to nothing and back to the same value changes nothing.
   */
  @Input() expandTrigger?: unknown;
  
  isExpanded = signal<boolean>(true);

  private lastTrigger: unknown;

  ngOnChanges(changes: SimpleChanges) {
    const trigger = changes['expandTrigger'];

    if (!trigger || trigger.currentValue == null) {
      return;
    }

    if (!trigger.firstChange && trigger.currentValue !== this.lastTrigger) {
      this.isExpanded.set(true);
    }

    this.lastTrigger = trigger.currentValue;
  }

  toggle() {
    if (this.collapsible) {
      this.isExpanded.update(v => !v);
    }
  }
}
